import PropTypes from 'prop-types';
import usePatchParams from './usePatchParams';
import ConversionBase from '../core/form/ConversionBase';
import { stringify } from '@/utils/miscUtils';

const ConversionField = ({
  name,
  unit,
  paramName,
  units,
  className = 'join-item border-l-0 text-right',
  disabled = false,
  readOnly = false,
  options = {},
}) => {
  const { patchUnit } = usePatchParams(options);
  const { value = '', is_default: isDefault } = unit ?? {};
  const unitValue = stringify(value);

  const onChange = async e => {
    const value = e.target.value;
    const unit = JSON.parse(value);

    await patchUnit(paramName, unit, name);
  };

  return (
    <ConversionBase
      name={name}
      value={unitValue}
      units={units}
      isDefault={isDefault}
      className={className}
      onChange={onChange}
      disabled={disabled}
      readOnly={readOnly}
    />
  );
};

ConversionField.propTypes = {
  name: PropTypes.string,
  unit: PropTypes.object,
  units: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  paramName: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  options: PropTypes.object,
};

export default ConversionField;
